import armenia from '../images/pizzas/armenian.png';
import assorty from '../images/pizzas/assorty.png';
import napolitano from '../images/pizzas/napolitano.png';
import peyzan from '../images/pizzas/peyzan.png';
import oriental from '../images/pizzas/oriental.png';
import americana from '../images/pizzas/americana.png';
import emiliana from '../images/pizzas/emiliana.png';
import pepperony from '../images/pizzas/pepperony.png';

export const pizzas = [
    {
        id: '1',
        name: 'Armenia',
        src: armenia,
        weight: 1000,
        price: 1200,
        type: 'armenian',
        quantity: 1
    },
    {
        id: '2',
        name: 'Assorty',
        src: assorty,
        weight: 950,
        price: 1500,
        type: 'italiano',
        quantity: 1
    },
    {
        id: '3',
        name: 'Napoletana',
        src: napolitano,
        weight: 1100,
        price: 2120,
        type: 'Napoletana',
        quantity: 1
    },
    {
        id: '4',
        name: 'Peyzan',
        src: peyzan,
        weight: 1350,
        price: 2500,
        type: 'peyzan',
        quantity: 1
    },
    {
        id: '5',
        name: 'Oriental',
        src: oriental,
        weight: 850,
        price: 2550,
        type: 'orintal',
        quantity: 1
    },
    {
        id: '6',
        name: 'Americana',
        src: americana,
        weight: 790,
        price: 2050,
        type: 'americana',
        quantity: 1
    },
    {
        id: '7',
        name: 'Emiliana',
        src: emiliana,
        weight: 1020,
        price: 1970,
        type: 'emiliana',
        quantity: 1
    },
    {
        id: '8',
        name: 'Pepperony',
        src: pepperony,
        weight: 1020,
        price: 2400,
        type: 'pepperony',
        quantity: 1
    },
]